import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f5ffda3"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2f5ffda3&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\前端\\项目\\rsj_wms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5ffda3')) {
      api.createRecord('2f5ffda3', component.options)
    } else {
      api.reload('2f5ffda3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f5ffda3", function () {
      api.rerender('2f5ffda3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon-svg/index.vue"
export default component.exports